module.exports = __webpack_public_path__ + "static/media/preloader-SMALL-PennyMac-Home.f442078b.gif";